import { render, staticRenderFns } from "./rightContent.vue?vue&type=template&id=67e77142&scoped=true&"
import script from "./rightContent.vue?vue&type=script&lang=js&"
export * from "./rightContent.vue?vue&type=script&lang=js&"
import style0 from "./rightContent.vue?vue&type=style&index=0&id=67e77142&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e77142",
  null
  
)

export default component.exports